import { API_TOKENS_STATUS } from './api-tokens.constants';

export const getActiveTokens = (tokens = []) =>
  tokens?.filter(item => item.status === API_TOKENS_STATUS.ACTIVE);
